import React,{ useEffect } from 'react';
import { Divider, Icon } from 'rsuite';
import $ from 'jquery';

const NuInsModal = ({show, onClose, devider, textHeader, children}) => {

    useEffect(() => {
        $("body" ).on( "click", ".side_container-content", onClose )

        return () => $("body" ).off( "click", ".side_container-content", onClose );
    },[onClose]);

    return (
        <>
            <div className={show ? "custom-modal-backdrop" : "custom-modal-backdrop_hide"}></div>
            <div className={show ? "custom-modal_open" : "custom-modal_close"} onClick={(event)=>{event.stopPropagation()}}>
                <div className="custom-modal-head" >
                    <p className="header-secondary" style={{ fontWeight: '500'}}>{textHeader}</p>
                    <div className="head-icon" onClick={onClose}><Icon icon="close" /></div>       
                </div>
                {devider ? <Divider /> : null}
                
                {children}
            </div>
        </>
    )
}

export default NuInsModal;